import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

const TestResultModal = ({ modalIsOpen, toggleModal }) => {
  const { t } = useTranslation();

  if (!modalIsOpen) return null;

  return ReactDOM.createPortal(
    <div className="test-result-modal__overlay" onClick={toggleModal}>
      <div className="test-result-modal__content" onClick={(event) => event.stopPropagation()}>
        <section className="welcome-message__result">
          <h3 className="welcome-message__result_title">{t('evieApp.assistant.testResultModal.title')}</h3>
          <p className="welcome-message__result_subtitle">{t('evieApp.assistant.testResultModal.subtitle')}</p>
          <p className="welcome-message__result_rate">{t('evieApp.assistant.testResultModal.rate')}</p>
          <p className="welcome-message__result_content">
            <Trans components={{ strong: <strong /> }}>evieApp.assistant.testResultModal.description</Trans>
          </p>
        </section>
      </div>
    </div>,
    document.body,
  );
};

TestResultModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
};

export default TestResultModal;
